import { options } from "floating-vue";

/**
 * floating-vue places a tooltip once and leaves it there, so one whose text changes while it is open
 * — "Copy" becoming "Copied" — grows off to one side of its button. Letting tooltips follow their
 * own size keeps them centred on what they point at.
 */
export default defineNuxtPlugin(() => {
  options.themes.tooltip!.handleResize = true;
});
